import getRegionalOptions from '../store/store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'setRoamingPrimaryTimezoneLabel',
    function setRoamingPrimaryTimezoneLabel(timezoneLabel: string) {
        const optionState = getRegionalOptions();
        optionState.roamingPrimaryTimezoneLabel = timezoneLabel;
    }
);
